import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../FirebaseComp/firebase'; // Assuming you have firebase.js configured
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import './awarenessprogram.css';

function AwarenessProgram() {
  const [formData, setFormData] = useState({
    organizationName: '',
    contactPerson: '',
    email: '',
    phone: '',
    eventDate: '',
    location: '',
    expectedParticipants: '',
    programDuration: '',
    targetAudience: '',
    specialRequirements: '',
    fundingNeeded: false,
    fundingDetails: '',
    termsAccepted: false
  });

  const [submissionStatus, setSubmissionStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionStatus('submitting');
    
    try {
      // Add document to Firestore
      const docRef = await addDoc(collection(db, 'awarenessprogramrequests'), {
        ...formData,
        submittedAt: serverTimestamp(),
        status: 'pending' // You can add status tracking
      });

      console.log('Document written with ID: ', docRef.id);
      setSubmissionStatus('success');
      setFormData({
        organizationName: '',
        contactPerson: '',
        email: '',
        phone: '',
        eventDate: '',
        location: '',
        expectedParticipants: '',
        programDuration: '',
        targetAudience: '',
        specialRequirements: '',
        fundingNeeded: false,
        fundingDetails: '',
        termsAccepted: false
      });
    } catch (error) {
      console.error('Error adding document: ', error);
      setSubmissionStatus('error');
    }
  };

  if (submissionStatus === 'success') {
    return (
      <div className="success-container">
        <div className="success-card">
          <svg className="success-icon" viewBox="0 0 24 24">
            <path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
          </svg>
          <h2>Request Submitted Successfully!</h2>
          <p>Thank you for your interest in our Eye Care Awareness Program. Our team will review your request and contact you within 3 business days.</p>
          <Link to="/" className="back-btn">Return to Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="awareness-program-container">
      <div className="program-header">
        <h1>Eye Care Awareness Program Request</h1>
        <p>Fill out this form to request our team to conduct an Eye Care Awareness Program for your organization or community.</p>
      </div>

      <form onSubmit={handleSubmit} className="program-form">
        <div className="form-section">
          <h3>Organization Information</h3>
          <div className="form-group">
            <label htmlFor="organizationName">Organization Name *</label>
            <input
              type="text"
              id="organizationName"
              name="organizationName"
              value={formData.organizationName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="contactPerson">Contact Person *</label>
            <input
              type="text"
              id="contactPerson"
              name="contactPerson"
              value={formData.contactPerson}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number *</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Event Details</h3>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="eventDate">Proposed Date *</label>
              <input
                type="date"
                id="eventDate"
                name="eventDate"
                value={formData.eventDate}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="location">Location *</label>
              <input
                type="text"
                id="location"
                name="location"
                value={formData.location}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="expectedParticipants">Expected Participants *</label>
              <select
                id="expectedParticipants"
                name="expectedParticipants"
                value={formData.expectedParticipants}
                onChange={handleChange}
                required
              >
                <option value="">Select range</option>
                <option value="1-50">1-50</option>
                <option value="51-100">51-100</option>
                <option value="101-200">101-200</option>
                <option value="201-500">201-500</option>
                <option value="500+">500+</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="programDuration">Preferred Duration *</label>
              <select
                id="programDuration"
                name="programDuration"
                value={formData.programDuration}
                onChange={handleChange}
                required
              >
                <option value="">Select duration</option>
                <option value="1 hour">1 hour</option>
                <option value="2 hours">2 hours</option>
                <option value="Half day">Half day</option>
                <option value="Full day">Full day</option>
                <option value="Multiple days">Multiple days</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="targetAudience">Target Audience *</label>
            <input
              type="text"
              id="targetAudience"
              name="targetAudience"
              value={formData.targetAudience}
              onChange={handleChange}
              placeholder="E.g., School children, Senior citizens, Corporate employees"
              required
            />
          </div>
        </div>

        <div className="form-section">
          <h3>Additional Information</h3>
          <div className="form-group">
            <label htmlFor="specialRequirements">Special Requirements</label>
            <textarea
              id="specialRequirements"
              name="specialRequirements"
              value={formData.specialRequirements}
              onChange={handleChange}
              placeholder="Any specific topics to cover, accessibility needs, etc."
              rows="3"
            />
          </div>

        </div>

        <div className="form-section terms-section">
          <div className="form-group checkbox-group">
            <input
              type="checkbox"
              id="termsAccepted"
              name="termsAccepted"
              checked={formData.termsAccepted}
              onChange={handleChange}
              required
            />
            <label htmlFor="termsAccepted">
              I agree to the <Link to="/terms">Terms and Conditions</Link> and understand that submission of this form doesn't guarantee program approval.
            </label>
          </div>
        </div>

        <div className="form-actions">
          <button
            type="submit"
            className="submit-btn"
            disabled={submissionStatus === 'submitting' || !formData.termsAccepted}
          >
            {submissionStatus === 'submitting' ? (
              <>
                <span className="spinner"></span> Submitting...
              </>
            ) : (
              'Submit Request'
            )}
          </button>
        </div>

        {submissionStatus === 'error' && (
          <div className="error-message">
            There was an error submitting your request. Please try again.
          </div>
        )}
      </form>
    </div>
  );
}

export default AwarenessProgram;